import React, { Component } from "react";

class About extends Component {
    render() {
        return (
            <main id="about">
                <h1 className="mb4 mt4">About</h1>
                <p className="mb4 f10pt fw2 lh-p">
                    ML News (<i>MLN</i> for short) is a community for sharing and{"\n"}
            discussing all things related to machine learning,{"\n"}
            deep learning, and AI.
        <br />
                    <br />
            We were inspired by{"\n"}
                    <a
                        href="https://news.ycombinator.com"
                        className="underline link"
                    >
                        Hacker News
            </a>,{"\n"}
                    <a
                        href="https://lobste.rs"
                        className="underline link"
                    >
                        Lobste.rs
            </a>,{"\n"}
                    <a
                        href="https://www.reddit.com/r/MachineLearning/"
                        className="underline link"
                    >
                        r/MachineLearning
            </a>,{"\n"}
            and the original{"\n"}
                    <a
                        href="https://web.archive.org/web/20000301205131/http://www.slashdot.org/"
                        className="underline link"
                    >
                        Slashdot
            </a>{"\n"}
            to create a dedicated place for experts and enthusiasts to engage in{"\n"}
            open learning, discussion, and occasional whimsy.
        <br />
                    <br />
            There are many different channels for tech-related news.{"\n"}
            In our experience, these are often flooded with not-so-relevant posts{"\n"}
            which somehow fall under the &quot;tech&quot; umbrella.{"\n"}
                    <br />
                    <br />
            We built MLN because we were already sharing interesting ML-related{"\n"}
            articles and research with friends and peers and we{"\n"}
            knew that we weren't the only ones. We hope that by narrowing the scope of this community{"\n"}
            to ML, we can build a space where people like us can easily find interesting news,{"\n"}
            breakthroughs, and updates in the field.
        <br />
                    <br />
            From ML experts to AI enthusiasts, this is a community that values honest debate,{"\n"}
            curiosity, positivity, and good humor. Please help us maintain these{"\n"}
            core values as the community grows.
        <br />
                    <br />
            You can access our RSS feed by going to mln.dev/rss from any RSS client.{"\n"}
            You can get the progressive web app by clicking the "Add To Home Screen"{"\n"}
            option on your mobile device (Chrome on Android, or Safari on iOS).
        <br />
                    <br />
            The MLN project is supported in part by <a className="underline link" href="https://www.paperspace.com">Paperspace</a>.
        </p>
            </main>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js